import {JSX} from 'react';
import {getI18n} from 'react-i18next';
import {useParams} from 'react-router-dom';

import {HealthReportWrapper} from '@/components/business/analytics/health-report/health-report-wrapper';
import LoadingView from '@/components/static/loading-view';
import {Page} from '@/decorators/page';
import {HealthReportDashboardTypeEnum} from '@/enum/health-report-dashboard-type-enum';
import {usePatientData} from '@/hooks/backend/use-patient-data';
import {PatientContextService} from '@/services/patient-context-service';

import { HealthReportLastAvailableNightRealtime } from './health-report-last-available-night-realtime';
import { HealthReportLastAvailableNightSpot } from './health-report-last-available-night-spot';

function wrapWithPage(Component: JSX.ElementType) {
    return Page({
        name: () => getI18n().t('healthReport.lastnight.title') ?? 'Health Report - last night',
        pagePath: () => ([
            {
                route: 'patients',
                name: 'Patients'
            },
        ]),
    })(Component);
}

type HealthReportLastAvailableNightPageProps = {
    params: {
        id_patient: string;
    },
    className: string,
};

function HealthReportLastAvailableNightPage_(props: HealthReportLastAvailableNightPageProps) {
    const params: Readonly<Partial<{
        id_patient: string;
    }>> = useParams();
    const patientId = params.id_patient ?? '';

    const [patientDataLoading, patientData] = usePatientData({
        patientId: patientId,
        memoize: true,
    });

    const loading = (
        (patientDataLoading || !patientData)
    );

    if (loading) {
        return (
            <HealthReportWrapper
                patientId={patientId}
                patientData={patientData}
                activeDashboard={HealthReportDashboardTypeEnum.LAST_24H}
            >
                <LoadingView />
            </HealthReportWrapper>
        );
    }
    //--------------------------------------------------------------------------------------------------------------

    const patientContext = PatientContextService.getPatientContext(patientData);
    if (patientContext.hasRealTimeMonitoring) {
        return (
            <HealthReportLastAvailableNightRealtime id_patient={patientId} className={props.className} />
        );
    }
    else {
        return (
            <HealthReportLastAvailableNightSpot id_patient={patientId} className={props.className} />
        );
    }
}

const HealthReportLastAvailableNightPage = wrapWithPage(HealthReportLastAvailableNightPage_);

export {HealthReportLastAvailableNightPage};
